import React, { useState } from "react";
import { addEnquiryForm } from "../../server/apihelper";
const EBrochureModal = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    type: 2,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addEnquiryForm(formData);
      onClose();
      window.open(
        "https://api.mcgansarch.com/uploads/e-brounchure/McgansE-Brouchure-2026.pdf",
        "_blank"
      );
    } catch (error) {
      console.error(error);
    }
  };

  if (!open) return null;

  return (
    <div className="ebrochure_overlay">
      <div className="ebrochure_modal">
        <h3>Download E-Brochure</h3>

        <form onSubmit={handleSubmit}>
          <input name="name" placeholder="Name" required value={formData.name} onChange={handleChange} />
          <input type="email" name="email" placeholder="Email ID" required value={formData.email} onChange={handleChange} />
          <input name="phone" placeholder="WhatsApp Number" required value={formData.phone} onChange={handleChange} />
          <input name="city" placeholder="Residence Place" required value={formData.city} onChange={handleChange} />
          <input name="state" placeholder="State" required value={formData.state} onChange={handleChange} />

          <div className="modal_btn_grp">
            <button className="submit_btn" type="submit">Submit</button>
            <button className="cancel_btn" type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EBrochureModal;
